import { stationList } from '@/api/station';

const station = {
  state: {
    list: [],
    pager: {
      pageSize: 20,
    },
  },

  mutations: {
    SET_STALIST: (state, list) => {
      state.list = list;
    },
    SET_STAPAGER: (state, pager) => {
      state.pager = {
        ...pager,
        showTotal: (total) => `共计 ${total} 条信息`,
      };
    },
  },
  actions: {
    async getStationList({ commit }, params) {
      const res = await stationList(params);
      if (res.code === 0) {
        commit('SET_STALIST', res.data.docs);
        commit('SET_STAPAGER', res.data.pager);
      }
    },
  },
};
export default station;
